import {Component, OnDestroy, OnInit} from '@angular/core';
import { ManageComplaintsEdittaskComponent } from '../manage-complaints-edittask/manage-complaints-edittask.component';
import { ManageComplaintsService } from '../../services/manage-complaints/manage-complaints.service';
import { ParComplaintsTasksService } from '../../services/par_complaints_tasks/par-complaints-tasks.service';
import { MatDialog } from '@angular/material';
import { MatPaginator, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatPaginatorIntl,PageEvent, MatExpansionModule, MatDialogRef } from '@angular/material';
import { Inject, ViewChild } from "@angular/core";
import * as moment from 'moment';
import { parComplaintsTasksDelDialog } from '../par-complaints-tasks-del-dialog/par-complaints-tasks-del-dialog.component';
import { SharedVals } from '../../../shared/SharedVals';
import { ISubscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-manage-complaint-viewtasks-dialog',
  templateUrl: './manage-complaint-viewtasks-dialog.component.html',
  styleUrls: ['./manage-complaint-viewtasks-dialog.component.css']
})

export class ManageComplaintViewtasksDialogComponent implements OnInit, OnDestroy {
  displayedColumns = ['LogDate', 'Request', 'CreatedUser', 'Status', 'DocumentName', 'FileEdit'];
  dataSource: MatTableDataSource<ViewTaskData>;
  public taskList: any;
  length: any;
  ispaginationFlag: boolean = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  pageEvent: PageEvent;
  pageSize = 10;
  message: string;
  errorMessage: String = '';
  errorEnable: boolean = false;
  hideDeleteButton: boolean = false;
  subscription: ISubscription;

  constructor(public manageComplaintService: ManageComplaintsService,
              public ParComplaintsTaskService : ParComplaintsTasksService,
              public dialog: MatDialog,
              @Inject(MAT_DIALOG_DATA) public complaintId: any,
              public dialogRef: MatDialogRef<ManageComplaintViewtasksDialogComponent>,
              public sharedVals: SharedVals) {
  }

  ngOnInit() {
    this.subscription = this.sharedVals.roleData.subscribe(roleData => {
      if (roleData === 'PC PAR Vendor Relations')
        this.hideDeleteButton = true;
    }, err => {
      
    });
    /*var role = localStorage.getItem('Role');
    if ((role === 'Resolution') || (role === 'QAC')){
          this.hideDeleteButton = true;
    }*/
    this.viewTaksList();
    this.refreshList();
  }

  refreshList(){
    this.ParComplaintsTaskService.load.subscribe(res=>{
      if(res === "success"){
        this.viewTaksList();
      }
    });
  }

  viewTaksList(){
    this.manageComplaintService.viewTasks(this.complaintId.complaintId.ComplaintId).subscribe(res => {
      if (!res.Tasks) {
        this.taskList = [];
        this.ispaginationFlag = false;
        this.dataSource = null;
        this.message = "No Tasks are available";
      } else {
        this.message = '';
        this.taskList = res.Tasks;
        for (let i = 0; i < this.taskList.length; i++) {
          if (this.taskList[i].LogDate !== '' && this.taskList[i].LogDate !== null && this.taskList[i].LogDate !== undefined) {
            var momentDate = moment(this.taskList[i].LogDate).format('MM/DD/YYYY');
            this.taskList[i].LogDate = momentDate;
          }
        }
        this.dataSource = new MatTableDataSource(this.taskList);
        this.dataSource.sort = this.sort;
        this.length = this.taskList.length;
        if (this.length <= 10) {
          this.ispaginationFlag = false;
        } else {
          this.ispaginationFlag = true;
        }
        if (this.paginator.pageIndex > 0 && (this.length % 10 == 0)) {
          this.paginator.pageIndex = this.paginator.pageIndex - 1;
        }
        this.dataSource.paginator = this.paginator;
        const paginatorIntl = new MatPaginatorIntl();
        paginatorIntl.itemsPerPageLabel = 'Items per page';
        paginatorIntl.nextPageLabel = 'Next page';
        paginatorIntl.previousPageLabel = 'Previous page';
        paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
          length = this.length;
          if (length == 0 || pageSize == 0) { return `0 van ${length}`; }
          length = Math.max(length, 0);
          const startIndex = page * pageSize;
          // If the start index exceeds the list length, do not try and fix the end index to the end.
          const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
          const round = Math.ceil(length / 10)
          return `${(startIndex / 10) + 1}  of ${round}`;
        }
        this.dataSource.paginator._intl = paginatorIntl;
      }
    }, err => {
      this.errorMessage = "View Tasks Service : " + err;
      this.errorEnable = true;
    });
  }

  editTask(taskData) {
    let dialogRef = this.dialog.open(ManageComplaintsEdittaskComponent, {
      disableClose: true,
      width: '55%',
      height: '80%',
      data: { taskInfo: taskData }
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  /*deleteManageComplaintTask(getDeleteData) {
      this.deleteId= getDeleteData._id;
      this.deleteComplaintTaskDetails(this.deleteId);
  }*/

  deleteComplaintTaskDetails(data) {
    const dialogRef = this.dialog.open(parComplaintsTasksDelDialog, {
      width: '400px',
      height: '250px',
      data: data
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  onNoClick() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
  }
}
export interface ViewTaskData {
  LogDate: Date;
  Request: String;
  CreatedUser: String;
  Status: String;
  DocumentName: String;
  FileEdit: any;
}



// WEBPACK FOOTER //
// ./src/app/components/manage-complaint-viewtasks-dialog/manage-complaint-viewtasks-dialog.component.ts